import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { companyLogin } from "../../slices/admin/authSlice";

const CompanyLogin = () => {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const dispatch = useDispatch();
    const { admin, error, loading } = useSelector((state) => state.adminauth);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(companyLogin({ email, password }));
    };

    useEffect(() => {
        if (admin) {
            navigate('/admin/dashboard');
        }
    }, [navigate, admin]);

    return (
        <div className="main-wrapper">
            <div className="account-content">
                <div className="row login-wrapper m-0">
                    <div className="col-lg-6 p-0">
                        <div className="login-content">
                            <form onSubmit={handleSubmit}>
                                <div className="login-userset">
                                    <div className="login-logo logo-normal">
                                        <img src="./logo.png" alt="img" />
                                    </div>
                                    <a href="index.html" className="login-logo logo-white">
                                        <img src="./logo.png" alt="Img" />
                                    </a>
                                    <div className="login-userheading">
                                        <h3>Sign In</h3>
                                        <h4>
                                            Access the Dreamspos panel using your email and passcode.
                                        </h4>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Email Address</label>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control border-end-0"
                                                value={email}
                                                id="email"
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                            <span className="input-group-text border-start-0">
                                                <i className="ti ti-mail" />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Password</label>
                                        <div className="pass-group">
                                            <input type="password" className="pass-input form-control" value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                id="password-input" />
                                            <span className="ti toggle-password ti-eye-off text-gray-9" />
                                        </div>
                                    </div>
                                    <div className="form-login authentication-check">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="custom-control custom-checkbox">
                                                    <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                                                        <input type="checkbox" />
                                                        <span className="checkmarks" />
                                                        Remember me
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-6 text-end">
                                                <a className="forgot-link" href="forgot-password-2.html">
                                                    Forgot Password?
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-login">
                                        <button type="submit" className="btn btn-login">
                                            Sign In
                                        </button>
                                    </div>
                                    {/* <div className="signinform">
                                        <h4>
                                            New on our platform?
                                            <a href="register-2.html" className="hover-a">
                                                {" "}
                                                Create an account
                                            </a>
                                        </h4>
                                    </div> */}

                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-6 p-0">
                        <div className="login-img">
                            <img
                                src="./frontend/img/authentication/authentication-01.svg"
                                alt="img"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        // <div className="auth-page-wrapper pt-5">
        //     <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
        //         <div className="bg-overlay" />
        //         <div className="shape">
        //             <svg
        //                 xmlns="http://www.w3.org/2000/svg"
        //                 version="1.1"
        //                 xmlnsXlink="http://www.w3.org/1999/xlink"
        //                 viewBox="0 0 1440 120"
        //             >
        //                 <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z" />
        //             </svg>
        //         </div>
        //     </div>
        //     <div className="auth-page-content">
        //         <div className="container">
        //             <div className="row">
        //                 <div className="col-lg-12">
        //                     <div className="text-center mt-sm-5 mb-4 text-white-50">
        //                         <div>
        //                             <a href="/login" className="d-inline-block auth-logo">
        //                             <h2 className="text-white mt-4">Point <span className="text-danger">of</span> Sale</h2>
        //                             </a>
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //             <div className="row justify-content-center">
        //                 <div className="col-md-8 col-lg-6 col-xl-5">
        //                     <div className="card mt-4 card-bg-fill">
        //                         <div className="card-body p-4">
        //                             <div className="text-center mt-2">
        //                                 <h5 className="text-primary">Welcome Back!</h5>
        //                                 <p className="text-muted">Sign in to continue to POS.</p>
        //                             </div>
        //                             <div className="p-2 mt-4">
        //                                 <form onSubmit={handleSubmit}>
        //                                     <div className="mb-3">
        //                                         <label htmlFor="email" className="form-label">
        //                                             Email
        //                                         </label>
        //                                         <input
        //                                             type="text"
        //                                             className="form-control"
        //                                             id="email"
        //                                             value={email} 
        //                                             onChange={(e) => setEmail(e.target.value)} 
        //                                             placeholder="Enter Email"
        //                                         />
        //                                     </div>
        //                                     <div className="mb-3">
        //                                         <div className="float-end">
        //                                             <a
        //                                                 href="auth-pass-reset-basic.html"
        //                                                 className="text-muted"
        //                                             >
        //                                                 Forgot password?
        //                                             </a>
        //                                         </div>
        //                                         <label className="form-label" htmlFor="password-input">
        //                                             Password
        //                                         </label>
        //                                         <div className="position-relative auth-pass-inputgroup mb-3">
        //                                             <input
        //                                                 type="password"
        //                                                 className="form-control pe-5 password-input"
        //                                                 placeholder="Enter password"
        //                                                 value={password} 
        //                                                 onChange={(e) => setPassword(e.target.value)}
        //                                                 id="password-input"
        //                                             />
        //                                             <button
        //                                                 className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon material-shadow-none"
        //                                                 type="button"
        //                                                 id="password-addon"
        //                                             >
        //                                                 <i className="ri-eye-fill align-middle" />
        //                                             </button>
        //                                         </div>
        //                                     </div>
        //                                     <div className="form-check">
        //                                         <input
        //                                             className="form-check-input"
        //                                             type="checkbox"
        //                                             defaultValue=""
        //                                             id="auth-remember-check"
        //                                         />
        //                                         <label
        //                                             className="form-check-label"
        //                                             htmlFor="auth-remember-check"
        //                                         >
        //                                             Remember me
        //                                         </label>
        //                                     </div>
        //                                     <div className="mt-4">
        //                                         <button disabled={loading} className="btn btn-success w-100" type="submit">
        //                                             Sign In
        //                                         </button>
        //                                     </div>
        //                                     {/* Render error if it exists */}
        //                                     {error && <p className="text-danger">{error.message || error}</p>}
        //                                 </form>
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        //     <footer className="footer">
        //         <div className="container">
        //             <div className="row">
        //                 <div className="col-lg-12">
        //                     <div className="text-center">
        //                         <p className="mb-0 text-muted">
        //                             © POS. Crafted with <i className="mdi mdi-heart text-danger" />{" "}
        //                             by POS
        //                         </p>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </footer>
        // </div>
    );
};
export default CompanyLogin;
